/* ty-branch-coach — הסבר קצר שמצביע על מתג הסניף, אחרי הפופאפ של הביקור הראשון.
   מעבדה 30.09.2026. חמש גרסאות בקובץ אחד, נבחרות ב-data-ty-coach על השורש
   או ב-#coach=a..e בכתובת (לבדיקה, מציג גם אם כבר נראה).

   🔴 אין נגיעה ב-ty-branch-switch.js. ההסבר מאזין לסגירת הפופאפ דרך
      data-ty-gate-shown על <html>, ולכן הוא חל על כל דרכי הסגירה:
      בחירה, איקס, רקע, Escape וסגירה אוטומטית.
   🔴 בחירה בסניף אחר מנווטת. אז data-ty-switching כבר על השורש כשהמשקיף רץ,
      וההסבר נדחה לדף הבא דרך sessionStorage. אחרת הוא היה מוצג על דף שנעלם.
   🔴 פעם אחת למכשיר (localStorage). כל מגע, גלילה או מקש סוגרים אותו. */
(function () {
  var SEEN = "ty_branch_coach_seen";
  var PENDING = "ty_branch_coach_pending";
  var html = document.documentElement;
  var el = null, ring = null, veil = null, timer = null, forced = false;

  function variant() {
    var m = (location.hash || "").match(/coach=([a-e][1-9]?)/);
    if (m) { forced = true; return m[1]; }
    return html.getAttribute("data-ty-coach") || "b6"; /* הכרעת יובל 30.09.2026: הילה רכה ובועה עגולה */
  }
  function seen() { try { return localStorage.getItem(SEEN) === "1"; } catch (e) { return false; } }
  function markSeen() { try { localStorage.setItem(SEEN, "1"); } catch (e) {} }

  function target() {
    var list = document.querySelectorAll(".ty-chip, .ty-sw");
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && getComputedStyle(list[i]).visibility !== "hidden") return list[i];
    }
    return null;
  }
  function branchName() {
    return (html.getAttribute("data-ty-branch-state") === "eilat" || /eilat/.test(html.className)) ? "אילת" : "מרכז";
  }

  var TEXT = {
    a: { b: "ניתן להחליף בין הסניפים בכל זמן שתרצה" },
    b: { b: "ניתן להחליף בין הסניפים בכל זמן שתרצה" },
    c: { h: "הסניף שבחרת נשמר כאן", b: "לחיצה על המתג מחליפה בין מרכז לאילת.", btn: "הבנתי" },
    d: { b: "הסניף שלך" },
    e: { b: null }
  };
  var LIFE = { a: 4000, b: 5000, c: 8000, d: 3500, e: 5000 };
  /* סבב 2, 30.09.2026: גרסאות b1 עד b5. אותה בועה כמו ב, קצרה יותר, ובכל אחת סגנון הדגשה אחר למתג. */
  var B_LIFE = 3000;

  function close() {
    clearTimeout(timer);
    [el, ring, veil].forEach(function (n) {
      if (!n) return;
      n.setAttribute("data-out", "1");
      setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 260);
    });
    el = ring = veil = null;
    html.removeAttribute("data-ty-coach-on");
    ["pointerdown", "keydown", "scroll", "resize"].forEach(function (t) { window.removeEventListener(t, onAny, true); });
  }
  function onAny(e) {
    /* המגע הראשון מגיע גם מההקשה שסגרה את הפופאפ. מתעלמים מ-300ms הראשונים. */
    if (Date.now() - shownAt < 300) return;
    close();
  }
  var shownAt = 0;

  function place(t, v) {
    var r = t.getBoundingClientRect();
    var W = document.documentElement.clientWidth, G = 16;
    var cx = r.left + r.width / 2;
    if (ring) {
      ring.style.left = (r.left - 4) + "px"; ring.style.top = (r.top - 4) + "px";
      ring.style.width = (r.width + 8) + "px"; ring.style.height = (r.height + 8) + "px";
    }
    if (!el) return;
    var bw = el.offsetWidth;
    var left = Math.min(Math.max(cx - bw / 2, G), W - G - bw);
    el.style.left = left + "px";
    el.style.top = (r.bottom + 14) + "px";
    el.style.setProperty("--tyco-ax", (cx - left) + "px");
  }

  function show(v) {
    if (el) return;
    var t = target();
    if (!t) return;
    v = v || variant();
    var base = v.charAt(0);
    var tx = TEXT[base];
    html.setAttribute("data-ty-coach-on", v);

    if (v === "c") {
      veil = document.createElement("div");
      veil.className = "tyco-veil";
      document.body.appendChild(veil);
    }
    if (base === "b" || v === "c" || v === "d") {
      ring = document.createElement("div");
      ring.className = "tyco-ring tyco-ring--" + (v === "b" ? "b tyco-ring--bp" : base === "b" ? "b tyco-ring--" + (v === "b6" ? "b2" : v) : v);
      ring.setAttribute("aria-hidden", "true");
      document.body.appendChild(ring);
    }

    el = document.createElement("div");
    el.className = "tyco tyco--" + base + (base === v ? "" : " tyco--" + v);
    el.setAttribute("role", "status");
    var inner = "";
    if (v === "e") {
      inner = '<span class="tyco__b">נבחר: <b>' + branchName() + '</b>. להחלפה, כאן</span>';
    } else {
      if (tx.h) inner += '<span class="tyco__h">' + tx.h + "</span>";
      inner += '<span class="tyco__b">' + tx.b + "</span>";
      if (tx.btn) inner += '<button type="button" class="tyco__btn">' + tx.btn + "</button>";
    }
    el.innerHTML = '<span class="tyco__arrow" aria-hidden="true"></span>' + inner;
    document.body.appendChild(el);
    place(t, v);
    /* b5: המסגרת מצוירת בגודל האמיתי של המתג. viewBox מתוח היה הופך את הקצוות העגולים לאליפסה. */
    if (v === "b5" && ring) {
      var rw = ring.offsetWidth, rh = ring.offsetHeight;
      ring.innerHTML = '<svg width="' + rw + '" height="' + rh + '" viewBox="0 0 ' + rw + ' ' + rh + '"><rect x="1.5" y="1.5" width="' + (rw - 3) + '" height="' + (rh - 3) + '" rx="' + ((rh - 3) / 2) + '" pathLength="100"/></svg>';
    }

    if (v === "e") {
      /* יוצא ממרכז המסך, במקום שבו היה הפופאפ, ונוסע אל המתג. */
      var r = el.getBoundingClientRect();
      var dy = window.innerHeight / 2 - r.top - r.height / 2;
      var dx = document.documentElement.clientWidth / 2 - r.left - r.width / 2;
      /* 🔴 place() כבר חישב פריסה, ולכן שינוי ההיסט עכשיו היה מונפש **אל** המרכז.
         ⟹ בלי מעבר בזמן הקביעה, קריאת פריסה שמקבעת את נקודת ההתחלה, ורק אז מעבר. */
      el.style.transition = "none";
      el.style.setProperty("--tyco-dx", dx + "px");
      el.style.setProperty("--tyco-dy", dy + "px");
      void el.offsetWidth;
      el.style.transition = "";
    }

    shownAt = Date.now();
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      if (el) el.setAttribute("data-in", "1");
      if (ring) ring.setAttribute("data-in", "1");
      if (veil) veil.setAttribute("data-in", "1");
    }); });
    ["pointerdown", "keydown", "scroll", "resize"].forEach(function (tp) { window.addEventListener(tp, onAny, true); });
    timer = setTimeout(close, base === "b" && v !== "b" ? B_LIFE : LIFE[v]);
    if (!forced) markSeen();
  }

  /* המשקיף: הפופאפ נסגר ⟵ עכשיו, או בדף הבא אם יש ניווט. */
  var wasOpen = html.hasAttribute("data-ty-gate-shown");
  new MutationObserver(function () {
    var open = html.hasAttribute("data-ty-gate-shown");
    if (wasOpen && !open && (forced || !seen())) {
      if (html.hasAttribute("data-ty-switching")) {
        try { sessionStorage.setItem(PENDING, "1"); } catch (e) {}
      } else {
        setTimeout(function () { show(); }, 350);
      }
    }
    wasOpen = open;
  }).observe(html, { attributes: true, attributeFilter: ["data-ty-gate-shown"] });

  function boot() {
    var p = null;
    try { p = sessionStorage.getItem(PENDING); sessionStorage.removeItem(PENDING); } catch (e) {}
    /* קישור בדיקה: אם הפופאפ פתוח, ההסבר מחכה לסגירתו דרך המשקיף. אחרת מוצג לבד. */
    if (/coach=[a-e][1-9]?/.test(location.hash || "")) {
      variant();
      setTimeout(function () { if (!html.hasAttribute("data-ty-gate-shown") && !el) show(); }, 1500);
      return;
    }
    if (p === "1" && !seen()) setTimeout(function () { show(); }, 700);
    /* ty-coach-always >>> 08.10.2026, יובל: «לא משנה מאיפה משתמש נכנס בפעם הראשונה — יהיה לו את ההסבר על המתג תמיד».
       החלון אינו נפתח בכניסה מקישור, ממודעה או מאתר אחר (כלל הנחיתה מ-03.09). אז ההסבר מופיע לבד.
       כשהחלון נפתח (או עומד להיפתח: data-ty-gate-pending), ההסבר מחכה לסגירתו דרך המשקיף, כמו תמיד. */
    else if (!seen()) setTimeout(function () {
      if (seen() || el || html.hasAttribute("data-ty-gate-shown") || html.hasAttribute("data-ty-gate-pending") || html.hasAttribute("data-ty-switching")) return;
      show();
    }, 1500);
    /* <<< ty-coach-always */
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.tyBranchCoach = { show: function (v) { forced = true; close(); show(v); }, close: close };
})();
